import cookie from 'react-cookies';

export const isMaverickFlow = () => {
	return cookie.load('maverickSession') != null || sessionStorage.getItem("ssRedirectUrl") != null;
};
